import { render, staticRenderFns } from "./ViewCounter.vue?vue&type=template&id=7f9e1812&scoped=true&"
import script from "./ViewCounter.vue?vue&type=script&lang=js&"
export * from "./ViewCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9e1812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f9e1812')) {
      api.createRecord('7f9e1812', component.options)
    } else {
      api.reload('7f9e1812', component.options)
    }
    module.hot.accept("./ViewCounter.vue?vue&type=template&id=7f9e1812&scoped=true&", function () {
      api.rerender('7f9e1812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/ViewCounter.vue"
export default component.exports